import { useLang } from '../hooks/useLanguage';
import IconTripAdvisor from '../icons/IconTripAdvisor';

const TripAdvisorWidget = function ({
    link = 'https://tripadvisor.com/',
    rating = 5,
    reviewCount = 0,
}) {
    const { t } = useLang();
    const maxRating = 5;
    const full = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.25 && rating % 1 <= 0.75;
    const empty = maxRating - full - (hasHalf ? 1 : 0);

    return (
        <div className="tripadvisor">
            <div className="tripadvisor__logo">
                <a
                    className="tripadvisor__logo-link"
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`TripAdvisor profile – rating: ${rating} out of ${maxRating} stars`}
                >
                    <IconTripAdvisor className="tripadvisor__logo-icon" />
                </a>
            </div>
            <div
                className="tripadvisor__rating"
                role="img"
                aria-label={`${rating} out of ${maxRating} stars`}
            >
                {[...Array(full)].map((_, i) => (
                    <span
                        key={`full-${i}`}
                        className="tripadvisor__rating-item tripadvisor__rating-item--full"
                    />
                ))}
                {hasHalf && (
                    <span className="tripadvisor__rating-item tripadvisor__rating-item--half" />
                )}
                {[...Array(empty)].map((_, i) => (
                    <span key={`empty-${i}`} className="tripadvisor__rating-item" />
                ))}
            </div>
            {reviewCount > 0 && (
                <div className="tripadvisor__reviewers">
                    <span className="tripadvisor__reviewers-text">
                        {reviewCount}{' '}
                        {reviewCount !== 1
                            ? t('widgetInformations.reviewers')
                            : t('widgetInformations.reviewer')}
                    </span>
                </div>
            )}
        </div>
    );
};

export default TripAdvisorWidget;
